<script>
  import SubmissionWizard from './Wizard'
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import SubmissionTextField from './fields/TextField'
  import SubmissionTextareaField from './fields/TextareaField'
  import FormSingleUpload from '../../../../components/form/SingleUpload'
  import * as restfulService from '../../../../services/restfulService'
  import bus from '@utils/bus'
  import {requiredIf} from 'vuelidate/lib/validators'

  export default {
    components: {
      SubmissionWizard,
      ValidationMessage,
      SubmissionTextField,
      SubmissionTextareaField,
      FormSingleUpload
    },
    props: ['submission'],
    data () {
      return {
        isSubmitted: false,
        data: {
          activeStep: 'contents',
          fields: [],
          knowledge_area_1_id: '',
          knowledge_area_2_id: '',
          knowledge_area_3_id: '',
          knowledge_area_4_id: '',
          invalidFile: false,
          emptyFile: true,
          event_paper_type: {
            knowledge_area: true
          }
        },
        dependencies: {
          knowledge_areas_level_1: [],
          knowledge_areas_level_2: [],
          knowledge_areas_level_3: [],
          knowledge_areas_level_4: []
        }
      }
    },
    computed: {
      customValidationCheck: function () {
        let validates = []
        this.data.fields.forEach((item) => {
          if (item.field.type !== 'file') {
            validates.push(item.isInvalid || item.isInvalid === undefined)
          }
        })
        return validates.some((item) => {
          return item === true
        })
      },
      needKnowledgeArea () {
        return this.data.event_paper_type.knowledge_area
      }
    },
    validations: {
      data: {
        knowledge_area_1_id: {
          required: requiredIf(function () {
            return this.needKnowledgeArea
          })
        },
        knowledge_area_2_id: {
          required: requiredIf(function () {
            return this.dependencies.knowledge_areas_level_2.length > 0 && this.data.knowledge_area_1_id > 0
          })
        },
        knowledge_area_3_id: {
          required: requiredIf(function () {
            return this.dependencies.knowledge_areas_level_3.length > 0 && this.data.knowledge_area_2_id > 0
          })
        },
        knowledge_area_4_id: {
          required: requiredIf(function () {
            return this.dependencies.knowledge_areas_level_4.length > 0 && this.data.knowledge_area_3_id > 0
          })
        }
      }
    },
    mounted: function () {
      if (!this.submission) {
        this.$router.push({name: 'submission.home'})
      }
      this.data = {...this.data, ...this.submission}
      this.data.activeStep = 'contents'
      this.getKnowledgeAreas(null, 1).then(() => {
        if (this.data.knowledge_area_1_id) {
          this.getKnowledgeAreas(this.data.knowledge_area_1_id, 2).then(() => {
            if (this.data.knowledge_area_2_id) {
              this.getKnowledgeAreas(this.data.knowledge_area_2_id, 3).then(() => {
                if (this.data.knowledge_area_3_id) {
                  this.getKnowledgeAreas(this.data.knowledge_area_3_id, 4)
                }
              })
            }
          })
        }
      })
      bus.$emit('hide-loader')
    },
    methods: {
      getKnowledgeAreas (knowledgeAreaId, level) {
        return new Promise((resolve, reject) => {
          let searchData = {
            knowledge_area_id: knowledgeAreaId,
            orderBy: [
              {
                column: 'name',
                direction: 'ASC'
              }
            ]
          }
          restfulService.search('knowledge_area', null, searchData, null, null, 1, 500)
            .then((response) => {
              if (level === 1) {
                this.dependencies.knowledge_areas_level_1 = []
                this.dependencies.knowledge_areas_level_1 = [...this.dependencies.knowledge_areas_level_1, ...response.data]
              } else if (level === 2) {
                this.dependencies.knowledge_areas_level_2 = []
                this.dependencies.knowledge_areas_level_2 = [...this.dependencies.knowledge_areas_level_2, ...response.data]
              } else if (level === 3) {
                this.dependencies.knowledge_areas_level_3 = []
                this.dependencies.knowledge_areas_level_3 = [...this.dependencies.knowledge_areas_level_3, ...response.data]
              } else {
                this.dependencies.knowledge_areas_level_4 = []
                this.dependencies.knowledge_areas_level_4 = [...this.dependencies.knowledge_areas_level_4, ...response.data]
              }
              resolve()
            })
            .catch(e => {
              reject(e)
            })
        })
      },
      changeKnowledgeArea (knowledgeAreaId, level) {
        if (level === 2) {
          this.data.knowledge_area_2_id = ''
          this.data.knowledge_area_3_id = ''
          this.data.knowledge_area_4_id = ''
        } else if (level === 3) {
          this.data.knowledge_area_3_id = ''
          this.data.knowledge_area_4_id = ''
        } else if (level === 4) {
          this.data.knowledge_area_4_id = ''
        }
        this.getKnowledgeAreas(knowledgeAreaId, level)
      },
      removeFile (field) {
        field.value = {
          name: '',
          base64: '',
          size: 0
        }
      },
      onNextStep (nextRoute) {
        this.isSubmitted = true
        if (nextRoute !== 'submission.home') {
          let knowledgeArea = null
          if (this.data.knowledge_area_1_id) {
            knowledgeArea = this.dependencies.knowledge_areas_level_1.filter((item) => {
              return item.id === this.data.knowledge_area_1_id
            })
          }
          if (this.data.knowledge_area_2_id) {
            knowledgeArea = this.dependencies.knowledge_areas_level_2.filter((item) => {
              return item.id === this.data.knowledge_area_2_id
            })
          }
          if (this.data.knowledge_area_3_id) {
            knowledgeArea = this.dependencies.knowledge_areas_level_3.filter((item) => {
              return item.id === this.data.knowledge_area_3_id
            })
          }
          if (this.data.knowledge_area_4_id) {
            knowledgeArea = this.dependencies.knowledge_areas_level_4.filter((item) => {
              return item.id === this.data.knowledge_area_4_id
            })
          }
          if (knowledgeArea && knowledgeArea.length) {
            this.data.knowledge_area = knowledgeArea[0]
          }
        }
        let params = {submission: this.data}
        this.$router.push({name: nextRoute, params})
      }
    }
  }
</script>

<template>
    <div class="submission-contents">
        <submission-wizard :active-step="data.activeStep"
                           :main-event="data.main_event"
                           :event="data.event"
                           :paper-type="data.paper_type"/>
        <div class="forms form-registration">
            <div class="buttons-center">
                <el-button type="default"
                           size="large"
                           @click="onNextStep('submission.home')">
                    <i class="fa fa-arrow-left"></i>
                    <span>Voltar</span>
                </el-button>
            </div>
            <el-alert title="Dicas da Submissão"
                      class="submission-tips"
                      type="warning"
                      :closable="false">
                <ul>
                    <li>Lembre-se de preencher todos os campos com * (asterisco), eles são obrigatórios.</li>
                    <li>Verifique o tamanhos dos campos e se a quantidade de caracteres está correta.</li>
                    <li>Utilize a vírgula para separar as palavras-chave.</li>
                </ul>
            </el-alert>
            <el-form ref="submission"
                     :model="data"
                     label-position="top">
                <div v-if="needKnowledgeArea">
                    <h3 class="title-separator">Área de Conhecimento</h3>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="Grande Área"
                                          v-bind:class="{
                                        'el-form-item--error': $v.data.knowledge_area_1_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_1.length > 0
                                      }">
                                <el-select v-model="data.knowledge_area_1_id"
                                           filterable
                                           clearable
                                           placeholder="Selecione uma opção"
                                           empty-text="Nenhum registro encontrado"
                                           class="el-select-full"
                                           @change="changeKnowledgeArea(data.knowledge_area_1_id, 2)"
                                           @input="$v.data.knowledge_area_1_id.$touch()">
                                    <el-option
                                            v-for="item in dependencies.knowledge_areas_level_1"
                                            :key="item.id"
                                            :label="'(' + item.cnpq_code + ') ' + item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <validation-message v-if="$v.data.knowledge_area_1_id.$error"></validation-message>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="Área"
                                          v-bind:class="{
                                        'el-form-item--error': $v.data.knowledge_area_2_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_2.length > 0 && this.data.knowledge_area_1_id > 0
                                      }">
                                <el-select v-model="data.knowledge_area_2_id"
                                           :disabled="data.knowledge_area_1_id === ''"
                                           filterable
                                           clearable
                                           placeholder="Selecione uma opção"
                                           empty-text="Nenhum registro encontrado"
                                           class="el-select-full"
                                           @change="changeKnowledgeArea(data.knowledge_area_2_id, 3)"
                                           @input="$v.data.knowledge_area_2_id.$touch()">
                                    <el-option
                                            v-for="item in dependencies.knowledge_areas_level_2"
                                            :key="item.id"
                                            :label="'(' + item.cnpq_code + ') ' + item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <validation-message v-if="$v.data.knowledge_area_2_id.$error"></validation-message>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="Sub-área"
                                          v-bind:class="{
                                        'el-form-item--error': $v.data.knowledge_area_3_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_3.length !== 0 && this.data.knowledge_area_2_id > 0
                                      }">
                                <el-select v-model="data.knowledge_area_3_id"
                                           :disabled="data.knowledge_area_2_id === ''"
                                           filterable
                                           clearable
                                           placeholder="Selecione uma opção"
                                           empty-text="Nenhum registro encontrado"
                                           class="el-select-full"
                                           @change="changeKnowledgeArea(data.knowledge_area_3_id, 4)"
                                           @input="$v.data.knowledge_area_3_id.$touch()">
                                    <el-option
                                            v-for="item in dependencies.knowledge_areas_level_3"
                                            :key="item.id"
                                            :label="'(' + item.cnpq_code + ') ' + item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <validation-message v-if="$v.data.knowledge_area_3_id.$error"></validation-message>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="Especialidade"
                                          v-bind:class="{
                                        'el-form-item--error': $v.data.knowledge_area_4_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_4.length !== 0 && data.knowledge_area_3_id > 0
                                      }">
                                <el-select v-model="data.knowledge_area_4_id"
                                           :disabled="data.knowledge_area_3_id === ''"
                                           filterable
                                           clearable
                                           placeholder="Selecione uma opção"
                                           empty-text="Nenhum registro encontrado"
                                           class="el-select-full"
                                           @input="$v.data.knowledge_area_4_id.$touch()">
                                    <el-option
                                            v-for="item in dependencies.knowledge_areas_level_4"
                                            :key="item.id"
                                            :label="'(' + item.cnpq_code + ') ' + item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <validation-message v-if="$v.data.knowledge_area_4_id.$error"></validation-message>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <h3 class="title-separator">Dados do Trabalho</h3>
                <el-form-item v-for="field in data.fields"
                              :key="field.field.id || field.field.slug || field.field.name"
                              :label="field.field.name"
                              class="is-required">
                    <submission-text-field v-if="field.field.type === 'text'"
                                           :model.sync="field.value"
                                           :min-length-size="field.field.min_size"
                                           :max-length-size="field.field.max_size"
                                           :placeholder="field.field.description"
                                           :show-helper="field.field.show_helper"
                                           :is-invalid.sync="field.isInvalid">
                    </submission-text-field>
                    <submission-textarea-field v-if="field.field.type === 'textarea'"
                                               :model.sync="field.value"
                                               :min-length-size="field.field.min_size"
                                               :max-length-size="field.field.max_size"
                                               :placeholder="field.field.description"
                                               :show-helper="field.field.show_helper"
                                               :is-invalid.sync="field.isInvalid">
                    </submission-textarea-field>
                    <div v-if="field.field.type === 'file'">
                        <form-single-upload :model.sync="field.value"
                                            :max-file-size="15"
                                            :accepted-types="'.pdf'"
                                            :is-empty.sync="data.emptyFile"
                                            :is-invalid.sync="data.invalidFile">
                        </form-single-upload>
                        <validation-message v-if="data.invalidFile"/>
                    </div>
                </el-form-item>
                <el-form-item class="buttons-save">
                    <el-button type="default"
                               size="large"
                               @click="onNextStep('submission.home')">
                        <i class="fa fa-arrow-left"></i>
                        <span>Voltar</span>
                    </el-button>
                    <el-button type="primary"
                               size="large"
                               @click="onNextStep('submission.authors')"
                               :disabled="isSubmitted || $v.data.$invalid || customValidationCheck || data.invalidFile || data.emptyFile">
                        <i class="fa fa-arrow-right"></i>
                        <span>Salvar e Avançar</span>
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<style lang="scss">
    .max-length {
        text-align: right;
        font-size: 13px;
        color: #a4a4a4;
        line-height: 22px;

        span {
            font-weight: bold;
            color: #333;
        }
    }
</style>
